import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/calculadora-dscr")({
  head: () =>
    buildHead({
      title: "Calculadora DSCR | Relación Renta / Deuda | Simply Approved",
      description:
        "Calcule su DSCR (Debt Service Coverage Ratio). Ingrese renta mensual, PITIA y otros datos para ver si la propiedad se autofinancia.",
      url: "/es/calculadora-dscr",
      locale: "es",
      keywords: "calculadora DSCR, calcular DSCR, ratio cobertura servicio deuda, renta vs pago préstamo",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Calculadora DSCR", url: "/es/calculadora-dscr" },
      ],
      service: { name: "Calculadora DSCR" },
    }),
  component: CalculatorPage,
});

function CalculatorPage() {
  return (
    <SiteShell>
      <PageHero eyebrow="Calculadora" title="Calcule su DSCR." subtitle="Use nuestra calculadora DSCR en inglés mientras preparamos la versión completa en español." />
      <Section>
        <SectionHeader title="Fórmula DSCR" center />
        <div className="mx-auto max-w-2xl rounded-2xl border border-border bg-card p-8 text-center">
          <p className="text-lg font-semibold text-foreground">DSCR = Renta mensual bruta ÷ Pago total mensual (PITIA)</p>
          <p className="mt-4 text-sm text-muted-foreground">
            Una relación mayor a 1.0 significa que la propiedad cubre su propio pago. Relaciones más
            altas indican mayor margen y menor riesgo para el prestamista.
          </p>
          <div className="mt-8">
            <Link to="/dscr-calculator" className="rounded-md bg-brand px-5 py-3 font-semibold text-primary-foreground hover:bg-brand-dark">
              Abrir calculadora DSCR
            </Link>
          </div>
          <p className="mt-4 text-xs text-muted-foreground">
            La calculadora interactiva está actualmente en inglés. Los resultados son ilustrativos y
            no representan una aprobación, oferta de crédito o tasa garantizada.
          </p>
        </div>
      </Section>
    </SiteShell>
  );
}
